export const PaymentOptions = [
    { key: "cash", value: "cash", text: "Cash" },
    { key: "revolut", value: "revolut", text: "Revolut" },
    { key: "bov", value: "bov", text: "BOV Mobile" },
    { key: "aps", value: "aps", text: "APS Mobile" },
    { key: "viva", value: "viva", text: "Viva" },
]